/*
 * Shared base configuration for OpenSeadragon components on the slide viewers
 */

export const MAX_ZOOM_LEVEL_FOR_BASE_VIEWER = 40;

export const viewerBaseConfig = {
  degrees: 180,
  visibilityRatio: 0.5,
  zoomPerClick: 3,
  zoomPerScroll: 1.7,
  constrainDuringPan: false,
  minZoomLevel: 0.5,
  showNavigator: true,
  rotationIncrement: 1,
  // Reduce animation time to reduce drag inertia
  animationTime: 0.6,
  silenceMultiImageWarnings: true,
  // OSD 6 starts one tile load per frame by default, which fills a large
  // monitor visibly tile by tile; the docs suggest 2-3.
  maxTilesPerFrame: 3,
  // When jumping straight to a deep zoom (bookmarks, fixed 20x/40x buttons)
  // load the target level instead of every blurry level on the way there.
  // Already cached lower levels are still drawn as placeholders.
  immediateRender: true,
  // Default is 200 decoded tiles per viewer; keep more so panning back over
  // an area already seen is served from memory rather than re-fetched.
  maxImageCacheCount: 400,
};
